<template>
  <div class="form-container">
    <div class="el-descriptions-title">评价信息</div>
    <eTableList
      :table-data="tableData"
      :table-label="tableLabel"
      :right-span-method="objectSpanMethod"
    ></eTableList>
    <template v-if="type === '1'">
      <div class="summary">
        <span class="margin-r10"
          >现场审查费：￥{{
            info.siteReviewFee | thousandsSeparator
          }}（首次申请时收取, 三年内无需再次支付）</span
        ><span class="margin-r10"
          >产品检测费：￥{{ info.amount | thousandsSeparator }}</span
        ><span>
          总评价费：￥<span class="total-price">{{
            info.totalAmount | thousandsSeparator
          }}</span></span
        >
      </div>
      <div
        v-if="
          info.evaluationBusinessConsultVOList &&
            info.evaluationBusinessConsultVOList.length
        "
        class="personnel-info"
      >
        <span class="margin-r20"
          >业务咨询人：{{
            info.evaluationBusinessConsultVOList[0].businessConsultName
          }}</span
        ><span class="margin-r20">{{
          info.evaluationBusinessConsultVOList[0].businessConsultTel
        }}</span
        ><span class="margin-r20">{{
          info.evaluationBusinessConsultVOList[0].businessConsultEmail
        }}</span
        ><span class="table-handle-btn" @click="visible = true"
          >查看更多业务咨询人&nbsp;&nbsp;></span
        >
      </div>
      <personnel-info
        :visible.sync="visible"
        :list="info.evaluationBusinessConsultVOList"
      />
    </template>
  </div>
</template>

<script>
import eTableList from '@/modules/projectA/components/common/e-table-list-merge';
import personnelInfo from './personnelInfo';
import { evaluativeInfoTableLabel } from './componentsData';
import Api from '@/modules/projectA/api/ESorganization';

export default {
  name: 'evaluativeInfo',
  components: { eTableList, personnelInfo },
  props: {
    // 1:订单，默认企业信息审核
    type: {
      type: String,
      default: ''
    },
    // 基础信息
    info: {
      type: Object,
      default: () => {
        return {};
      }
    },
    flag: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const tableLabel = [...evaluativeInfoTableLabel];
    // 订单详情
    if (this.type === '1') {
      // 删除专业
      tableLabel.splice(2, 1);
    }
    return {
      tableLabel,
      tableData: [],
      visible: false
    };
  },
  created() {
    const params = {
      applyId: this.$route.query.applyId,
      noProperFlag: this.flag
    };
    console.log(params, 'params');
    Api.queryEvaluationApplyItemInfo(params).then(res => {
      if (res.code === '200') {
        const list = [];
        res.data.forEach(item => {
          item.evaluationApplyItemPriceVOList.forEach((item2, index) => {
            list.push({
              ...item,
              ...item2,
              evaluationApplyItemPriceVOList: undefined,
              // span: 2
              span: index === 0 ? item.evaluationApplyItemPriceVOList.length : 0
            });
          });
        });
        this.tableData = list;
      }
    });
  },
  methods: {
    /**
     * 合并单元格
     * @param row
     * @param columnIndex
     * @returns {{colspan: number, rowspan: *}|{colspan: number, rowspan: number}}
     */
    objectSpanMethod({ row, columnIndex }) {
      if (columnIndex < (this.type === '1' ? 3 : 4)) {
        if (row.span) {
          return {
            rowspan: row.span,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'common';

.summary {
  padding: 17px 10px;
  text-align: right;
  font-size: 12px;
  font-style: normal;
  font-weight: 350;
  line-height: 16px;
  border: 1px solid #ebeef5;
  border-top: 0;
}

.personnel-info {
  margin-top: 20px;

  > span {
    font-style: normal;
    font-weight: 350;
    font-size: 14px;
    line-height: 14px;
  }
}
</style>
